import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldIcon, CreditCardIcon, FileTextIcon, FlagIcon } from 'lucide-react';
export function FinalCTA() {
  const trustBadges = [{
    icon: <LockIcon className="w-4 h-4" data-id="element-68" />,
    text: 'Pago 100% seguro'
  }, {
    icon: <ZapIcon className="w-4 h-4" data-id="element-69" />,
    text: 'Acceso en 5 minutos'
  }, {
    icon: <ShieldIcon className="w-4 h-4" data-id="element-70" />,
    text: 'Garantía 7 días'
  }, {
    icon: <CreditCardIcon className="w-4 h-4" data-id="element-71" />,
    text: 'Mercado Pago · Tarjeta · Transferencia'
  }, {
    icon: <FileTextIcon className="w-4 h-4" data-id="element-72" />,
    text: '100% PDF'
  }, {
    icon: <FlagIcon className="w-4 h-4" data-id="element-73" />,
    text: 'Hecho en Argentina'
  }];
  return <section className="w-full bg-[#FBEDE5] donut-pattern py-4 md:py-8" data-id="element-74">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-76">
          <div className="max-w-2xl mx-auto mb-3 md:mb-6" data-id="element-77">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-gradient-to-b from-white to-[#FBF5EC] border-2 border-[#B8855C] rounded-lg p-5 md:p-6 relative shadow-md" data-id="element-78">
              <h4 className="text-xl font-bold text-[#3D2817] mb-1" data-id="element-79">
                🍩 MEGA PACK EMPRENDE MINIDONAS 360
              </h4>
              <p className="text-[#B45309] font-semibold mb-2 text-sm" data-id="element-80">
                6 Tomos + 4 Bonos · Masa → Negocio en Pesos
              </p>
              <div className="mb-3" data-id="element-81">
                <div className="flex items-center gap-2 mb-1" data-id="element-82">
                  <span className="text-[#9B8770] line-through text-lg" data-id="element-83">
                    $58.960
                  </span>
                  <span className="bg-[#B85450] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-84">
                    -71% OFF
                  </span>
                </div>
                <div className="flex items-baseline gap-2" data-id="element-85">
                  <span className="text-[#B45309] font-bold text-3xl" data-id="element-86">
                    $16.990
                  </span>
                  <span className="text-[#9B8770] text-sm" data-id="element-87">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48199368966336:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-[#B45309] hover:bg-[#92400E] text-white font-bold text-lg px-6 py-3.5 rounded-lg transition-colors shadow-lg shadow-[#7A4A2B]/30 text-center" data-id="element-88">
                🔴 → QUIERO MI MEGA PACK AHORA
              </motion.a>

              <motion.a href="https://wa.me/543516347235?text=Hola!!%20Quiero%20abonar%20el%20Mega%20Pack%20Emprende%20Minidonas%20360%20con%20transferencia%20bancaria%20y%20aprovechar%20el%2015%25%20de%20descuento.%20Gracias!!" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="mt-2 flex items-center justify-center gap-2 w-full bg-white hover:bg-[#F0FAF3] border-2 border-[#25D366] text-[#1ebe5b] font-semibold text-sm px-4 py-2.5 rounded-lg transition-colors text-center" data-id="element-89">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-90">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" data-id="element-91" />
                </svg>
                💸 Pagar por transferencia — 15% OFF ($14.441)
              </motion.a>
            </motion.div>
          </div>

          <div className="flex flex-wrap gap-1.5 md:gap-2 items-center justify-center" data-id="element-92">
            {trustBadges.map((badge, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3
          }} className="flex items-center gap-1 md:gap-1.5 bg-white border border-[#E8D5BA] rounded-full px-2 py-1 md:px-3 md:py-1.5 shadow-sm" data-id="element-93">
                <span className="text-[#B45309] [&>svg]:w-3 [&>svg]:h-3 md:[&>svg]:w-4 md:[&>svg]:h-4" data-id="element-94">
                  {badge.icon}
                </span>
                <span className="text-[10px] md:text-xs text-[#6B5747] font-medium leading-tight" data-id="element-95">
                  {badge.text}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}